import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
var StyledCircle = styled("div")({
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "var(--red-color-10)",
    border: "1px solid #F48686",
});
var CircleComponent = function () {
    return _jsx(StyledCircle, {});
};
export default CircleComponent;
